<template>
<div>

	<!-- page-heading -->
	<page-heading :show="true" pageTitle="CPT-HEADER"></page-heading>

	<div class="columns">

		<div class="col-main">

			<!-- show loading indicator -->
			<loading-indicator :loading="isLoading"></loading-indicator>

			<div v-if="!isLoading">

				<v-client-table ref="tblContentPoolTopics" name="tblContentPoolTopics" :data="table.tblData" :columns="table.tblColumns" :options="table.tblOptions" class="tblcontentPoolTopics noFirstColumn">

					<!-- before table: FILTER OPTIONS -->
					<template slot="beforeTable">
						<div class="control has-icon search is-pulled-left">
							<input class="input" type="text" v-model.trim="searchString" placeholder="Suchbegriff">
							<i class="fa fa-search" aria-hidden="true"></i>
						</div>
					</template>

                    <!-- startDate -->
					<template slot="startDate" slot-scope="props">
		                {{ formatDate2(props.row.startDate, false) }}
					</template>

                    <!-- endDate -->
					<template slot="endDate" slot-scope="props">
		                {{ formatDate2(props.row.endDate, false) }}
					</template>

					<!-- delete -->
					<template slot="delete" slot-scope="props">
						<span class="del icon is-small" @click.prevent.stop="deleteTopic(props)">
							<i class="icon-ak-entfernen"></i>
						</span>
					</template>

				</v-client-table>

			</div>

		</div>

        <div class="col-aside">

    		<affix :offset="50">

                <div class="sidebox">
					<custom-button type="blue" name="CPT-BTN-TOPIC_ADD" icon="icon-ak-hinzufuegen" @click.native="newTopic"></custom-button>
				</div>

    		</affix>

        </div>

    </div>

</div>

</template>





<script>
import Vue from 'vue';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');

export default {

    name: 'equipmentCategories',

	components: {

	},

	data() {

        return {
            isLoading: true,
            searchString: null,
			showCategoriesNotInCatalog: false,
            table: {

                tblColumns: ['name', 'startDate', 'endDate', 'color', 'delete'],
                tblData: [],
                tblOptions: {
                    trackBy: 'id',
                    uniqueKey: 'id',
                    saveState: true,
                    perPage: 25,
                    orderBy: {
                        ascending: true,
                        column: 'startDate'
                    },

                    // custom table headings - make them clickable for language Setting
                    headings: {

                        name: function(h) {
                            return <lang labelKey="CPT-TBL_HEADER-NAME"></lang>
                        },
                        startDate: function(h) {
                            return <lang labelKey="CPT-TBL_HEADER-STARTDATE"></lang>
                        },
                        endDate: function(h) {
                            return <lang labelKey="CPT-TBL_HEADER-ENDDATE"></lang>
                        },
                        color: function(h) {
                            return <lang labelKey="CPT-TBL_HEADER-COLOR"></lang>
                        },
						delete: function(h) {
                            return <lang labelKey="CPT-TBL_HEADER-DELETE"></lang>
                        },
                    },

                    sortable: ['name', 'startDate', 'endDate'],
					sortIcon: {
                        base:'fa',
                        up:'fa-sort-up',
                        down:'fa-sort-down',
                        is:'fa-sort'
                    },
                    filterByColumn: false,
                    filterable: false,

                    texts: {
                        filter: 'Filter Ergebnisse:',
                        filterPlaceholder: 'Suche',
                        limit: 'Einträge pro Seite',
                        noResults: 'keine passenden Einträge gefunden',
                        count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
                    },

                    pagination: {
                        chunk: 5
                    },

                    skin: 'table is-striped is-hoverable is-fullwidth',

                    templates: {

                        category: function(h, row) {
                            return self.equipmentCategories.find(cat => cat.id == row.category).name;
                        },

                    },

                    // custom filter functions
                    customFilters: [
                        {
                            name: 'search',
                            callback: function(row, string) {

                                if(string == null || string == "") {
                                    return true;
                                }

                                string = string.toLowerCase();

                                return row.name != null && row.name.toLowerCase().indexOf(string) >= 0;

                            }
                        },

                    ],

                    rowClassCallback: function(row) {

                    }

                }
            }

        }
    },

    created() {

        this.fetchData();

    },

    mounted() {

        Event.$on('vue-tables.tblContentPoolTopics.row-click', function (data) {

			if(['icon-ak-entfernen', 'page'].indexOf(data.event.target.className) > -1) {
				return false;
			}

            this.$router.push({ name: 'complatContentPoolTopic', params: { 'topicID': data.row.id }  });

        }.bind(this));

    },


	watch: {

		searchString(val) {

			Event.$emit('vue-tables.tblContentPoolTopics.filter::search', val);

		}

	},


    methods: {

		search() {

			var self = this;

            setTimeout(function() {
                Event.$emit('vue-tables.tblContentPoolTopics.filter::search', self.searchString );
            }, 10);

		},

        newTopic() {

            this.$router.push({ name: 'complatContentPoolTopicNew' });

	    },

		deleteTopic(props) {

			// find the index of the clicked row first
			var foundIndex = "";
			this.table.tblData.forEach(function(row, index) {
				if(row.id == props.row.id) {
					foundIndex = index;
				}
			})

			// if we found an index, delete the category in the DB
			// and remove it from the array
			if(foundIndex >= 0) {

				var self = this;
				this.entityDelete('articleTopic', this.table.tblData[foundIndex].id, 'CPT-MSG-CONFIRM_DELETION')
					.then(function(response) {
						self.table.tblData.splice(foundIndex, 1);
					})
			}

		},

        fetchData() {

			this.isLoading = true;
			var self = this;

			// make the request
			this.axios.get(self.$config.api + 'articleTopic')
                .then(function(response) {

					self.table.tblData = response.data.articleTopic;
					self.isLoading = false;

                }).catch(function(error) {
                    self.isLoading = false;
					console.log(error);
				});
		},

    }

}
</script>


<style>
.tblcontentPoolTopics th:last-child,
.tblcontentPoolTopics td:last-child {
    max-width: 90px;
    width: 90px;
    text-align: center;
    background-color: rgba(255,255,255,0.3);
}

</style>
